module.exports = __webpack_public_path__ + "img/fotofamiliar(1).da034cf8.png";